import { type FunctionComponent } from 'react';
import cx from 'classnames';
import type React from 'react';

interface Props {
  children: React.ReactNode;
  isTripsPanelOpened: boolean;
}

const RightSideControls: FunctionComponent<Props> = ({ children, isTripsPanelOpened }) => {
  return <div className={cx('map-right-controls-container', { expanded: isTripsPanelOpened })}>{children}</div>;
};

export default RightSideControls;
